export const pollutants = [
  {
    name: "All Pollutants",
    value: "All Pollutants",
  },
  {
    name: "CH4",
    value: "CH4",
  },
  {
    name: "CO",
    value: "CO",
  },
  {
    name: "CO2",
    value: "CO2",
  },
  {
    name: "N20",
    value: "N20",
  },
  {
    name: "NH3",
    value: "NH3",
  },
  {
    name: "NOx",
    value: "NOx",
  },
  {
    name: "VOC",
    value: "VOC",
  },
  {
    name: "SO2",
    value: "SO2",
  },
  {
    name: "PM10",
    value: "PM10",
  },
  {
    name: "PM2.5",
    value: "PM2.5",
  },
  {
    name: "BC",
    value: "BC",
  },
  {
    name: "OC",
    value: "OC",
  },
];
